import React from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import DialogModal from 'shared/components/DialogModal';

const ModalInformasi = ({ open, handleClose = () => {} }) => {
    return (
        < DialogModal
            size='sm'
            open={open}
            title={'Informasi'}
            handleClose={() => handleClose(false)}
        >
            <Typography fontSize={16}>
                Menu ini merupakan implementasi dari Aksi Perubahan New Integrated Learning and Office System
                (NILAM) pada Portal Collaboration Office.
            </Typography>
        </DialogModal >
    )
}

ModalInformasi.propTypes = {
    open: PropTypes.bool,
    handleClose: PropTypes.func
};

export default ModalInformasi